// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1NdYO","title":"InfoRow_title__1Dslv"};